var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListaParametros',{attrs:{"url":"/admin/configuracoes","descPlural":"Integrações","descSingular":"Integração"}})
}
var staticRenderFns = []

export { render, staticRenderFns }